export default "__VITE_ASSET__xrJzmYq___"